import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/about/banner.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4dee768b")

_pushScopeId("data-v-4dee768b")
const _hoisted_1 = { class: "about-system" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row about-system__top" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-12 mb-5 col-md-6 mb-md-0 col-lg-5" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "",
    class: "about-system__banner"
  })
], -1)
const _hoisted_5 = { class: "col-12 col-md-6 col-lg-7" }
const _hoisted_6 = { class: "about-system__banner-text" }
const _hoisted_7 = { class: "about-system__list" }
const _hoisted_8 = { class: "row about-system__bottom" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "video" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_AboutList = _resolveComponent("AboutList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BreadCrumbs, { links: [{ to: 'about-system', name: 'adaptiveTop.about' }] }),
      _createVNode(_component_SectionTitle, {
        title: _ctx.$t('pages.about.title1'),
        class: "about-system__title"
      }, null, 8, ["title"]),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("p", null, _toDisplayString(_ctx.$t('pages.about.text1')), 1),
            _createVNode("p", null, _toDisplayString(_ctx.$t('pages.about.text2')), 1)
          ]),
          _createVNode("ul", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, itemInd) => {
              return (_openBlock(), _createBlock("li", {
                key: itemInd,
                class: "about-system__item"
              }, [
                _createVNode(_component_svg_icon, {
                  name: item.icon,
                  class: "about-system__item"
                }, null, 8, ["name"]),
                _createVNode("span", null, _toDisplayString(_ctx.$t(item.text)), 1)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _createVNode(_component_AboutList, {
        class: "about-system__mob-list",
        list: _ctx.list
      }, null, 8, ["list"]),
      _createVNode(_component_SectionTitle, {
        title: _ctx.$t('pages.about.title2'),
        class: "about-system__title"
      }, null, 8, ["title"]),
      _createVNode("div", _hoisted_8, [
        _createVNode("p", null, _toDisplayString(_ctx.$t('pages.about.text3')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('pages.about.text4')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('pages.about.text5')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('pages.about.text6')), 1),
        _hoisted_9
      ])
    ])
  ]))
})